<style lang="scss" scoped>
.timeline-container {
  display: flex;
  flex-wrap: wrap;
  @media only screen and (min-width: 576px) {
    height: 150px;
  }
  .in-bed {
    width: 75px;
    margin: auto 0;
    @media only screen and (max-width: 576px) {
      font-size: 12px;
      width: 35px;
      margin-right: 15px;
      text-align: left;
    }
  }
  .timeline {
    width: calc(100% - 75px * 2);
    display: flex;
    flex-wrap: wrap;
    @media only screen and (max-width: 576px) {
      width: calc(100% - 50px * 2);
    }
    .line {
      width: 100%;
      height: 16px;
      background-color: var(--border-color);
      margin: auto 0;
      position: relative;
      .hover-line {
        position: absolute;
        width: 100%;
        height: 800%;
        left: 0;
        top: -350%;
        cursor: pointer;
      }
      .milestone {
        position: absolute;
        width: 1px;
        height: 64px;
        background-color: var(--dark);
        top: -22px;
        user-select: none;
        span {
          position: absolute;
          bottom: -20px;
          left: -14px;
        }
        .icon {
          position: absolute;
          top: -30px;
          left: -10px;
        }
      }
      .hour {
        height: 100%;
        width: 1px;
        position: absolute;
        margin-left: -0.5px;
        background: #b4b6b7;
      }
      .current-item {
        position: absolute;
        padding: 16px;
        box-shadow: 0 0 8px rgba(0, 0, 0, 0.16);
        background-color: #ffffff;
        top: 30px;
        transform: translateX(-50%);
        z-index: 1;
        .input-container {
          width: 40%;
        }
        .trash {
          width: 20%;
          margin: auto auto 16px auto;
        }
      }
      .marker-blocker {
        position: absolute;
        height: 150px;
        top: -65px;
        width: 100%;
        z-index: 1;
        &:hover {
          & ~ .current-item {
            display: none;
          }
        }
      }
      .wakeup {
        cursor: pointer;
        z-index: 2;
        &:hover {
          background-color: var(--el-wakeup-wakeup-color-hover);
          .ghost-milestone {
            opacity: 1;
          }
        }
        .ghost-milestone {
          font-size: 70%;
          position: absolute;
          top: -20px;
          color: var(--el-wakeup-wakeup-color);
          opacity: 0;
          &.start {
            left: 0;
          }
          &.end {
            right: 0;
          }
        }
      }
      .wakeup,
      .ghost-wu {
        position: absolute;
        top: -4px;
        height: 8px;
        background-color: var(--el-wakeup-wakeup-color);
        border-radius: 3px;
      }
      .ghost-wu {
        // transform: translateX(-50%);
        opacity: 0.1;
        pointer-events: none;
      }
    }
  }
  .out-bed {
    width: 75px;
    text-align: right;
    margin: auto 0;
    @media only screen and (max-width: 576px) {
      font-size: 12px;
      width: 35px;
      margin-left: 15px;
      text-align: right;
    }
  }
}
.pe-none {
  pointer-events: none;
}
.timeput {
  padding: 14.5px;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid var(--border-color) !important;
  border-radius: 2px;
  outline: none;
  &::-webkit-clear-button,
  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0;
  }
}
::v-deep .dropdown {
  .hours {
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: #fff;
    }
    &::-webkit-scrollbar-thumb {
      transition: background 0.3s;
      background: rgba(0, 0, 0, 0);
    }
  }
}
</style>

<template>
    <div>
        <div class="timeline-container" v-if="inBed && outBed && awake && asleep">

            <div class="d-none d-lg-block in-bed text-right">{{ inBed }}</div>
            <div class="d-none d-lg-flex timeline" ref="timeline">
                <div class="line mx-auto" v-click-outside="handleMarkerClickedOutside" :style="{ width: `${(tst / 15) * normalised_15}px`}">
                    <template v-if="!mobile">
                        <span class="milestone left" :style="{ left : (time_in_sleep / 15) * normalised_15  + 'px', 'margin-left' : '-1.5px' }">
                            <slot name="to-sleep-icon">
                                <i-to-sleep class="i-20 icon"></i-to-sleep>
                            </slot>
                            <span class="small">{{ asleep }}</span>
                        </span>
                        <span class="milestone right" :style="{ right : (time_out_sleep / 15) * normalised_15 + 'px' , 'margin-right' : '-1.5px'}">
                            <slot name="wakeup-icon">
                                <i-wakeup class="i-20 icon"></i-wakeup>
                            </slot>
                            <span class="small">{{ awake }}</span>
                        </span>
                        <span class="hour" v-for="(hour, index) in hours" :key="'h_' + index" :style="{ left : (4 * normalised_15) * (index + 1) + 'px' }"></span>
                    </template>
                    <div class="hover-line" ref="line"></div>

                    <div class="marker-blocker" v-for="(wu, index) in wakeups" :key="'wu_blocker_' + index" :style="{ left : wu.left + 'px', width: wu.width + 'px' }" :class="{ 'pe-none' : dragging }"></div>
                    <div v-for="(wu, index) in wakeups" :key="'wu_' + index" class="wakeup" :class="{ 'pe-none' : dragging }" :style="{ left : wu.left + 'px', width: wu.width + 'px', '--el-wakeup-wakeup-color': wakeupColor, '--el-wakeup-wakeup-color-hover': wakeupColorHover }" @mousedown="markerMouseDown($event, wu, index)" @click="handleMarkerClicked($event, wu, index)">
                        <div v-if="wu.width > 65" class="ghost-milestone start">{{ wu.start }}</div>
                        <div v-if="wu.width > 65" class="ghost-milestone end">{{ wu.end }}</div>
                        <div v-if="editing_index === index" @click.stop @mousedown.stop class="current-item d-flex" :style="{ left : '50%', width: '300px' }">
                            <span class="mr-2 d-flex flex-column small input-container">
                                <span class="text-primary-dark mb-4 text-center">{{ $t('pages.schedule.time') }}</span>
                                <el-timepicker v-model="wu.mobile_time" :zero-based="true" @change="handleMobileWakupUpdate(wu)" :minute-interval="15" :hide-clear-button="true" :disabled-hours="disabledHours"></el-timepicker>
                            </span>
                            <span class="mx-2 d-flex flex-column small input-container wu-dur-timepicker">
                                <span class="text-primary-dark mb-4 text-center">{{ $t('pages.schedule.duration') }}</span>
                                <el-timepicker v-model="wu.mobile_duration" :zero-based="true" @change="handleMobileWakupUpdate(wu)" :minute-interval="15" :hide-clear-button="true"></el-timepicker>
                            </span>
                            <i-trash class="i-20 trash" @click="removeWakeup(index)"></i-trash>
                        </div>
                    </div>

                    <template v-if="!mobile">
                        <div v-if="currentItem.visible && !dragging" class="ghost-wu" :style="{ left : currentItem.left + 'px', width: normalised_15 + 'px' }"></div>
                        <div v-if="currentItem.visible" class="current-item" :class="{ 'pe-nones' : currentItem.visible }" :style="{ left : currentItem.left + 'px' }">
                            <span>{{ currentItem.time }}</span>
                        </div>
                    </template>
                </div>
            </div>
            <div class="d-none d-lg-block out-bed text-left">{{ outBed }}</div>

            <div class="row" v-if="mobile">
                <p class="fw-b col-12 mt-16 mb-16">
                    <slot name="mobile-label">
                        {{ $t('pages.schedule.did_you_wakeup_inbetween_shift') }}
                    </slot>
                </p>
                <div class="col-12 mb-16" v-for="(wu, index) in wakeups" :key="`wu_${index}`">
                    <div class="row">
                        <div class="col-11">
                            <div class="row">
                                <div class="col-6 d-flex">
                                    <span class="my-auto d-block mb-16 text-primary-dark mr-8 text-center small">{{ $t('pages.schedule.time') }}</span>
                                    <el-timepicker class="w-100" v-model="wu.mobile_time" :zero-based="true" @change="handleMobileWakupUpdate(wu)" :minute-interval="15" :hide-clear-button="true" :disabled-hours="disabledHours"></el-timepicker>
                                </div>
                                <div class="col-6 d-flex">
                                    <span class="my-auto d-block mb-16 text-primary-dark mr-8 text-center small">{{ $t('pages.schedule.duration') }}</span>
                                    <el-timepicker class="w-100" v-model="wu.mobile_duration" :zero-based="true" @change="handleMobileWakupUpdate(wu)" :minute-interval="15" :hide-clear-button="true"></el-timepicker>
                                </div>
                            </div>
                        </div>
                        <div class="col-1 d-flex px-0">
                            <i-cross class="i-17 my-auto fill-gray fill-dark-hover c-pointer" @click="wakeups.splice(index,1); handleMobileWakupUpdate(wu)" />
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div class="col-11">
                            <div class="row">
                                <div class="col-6 d-flex">
                                    <span class="my-auto d-block mb-16 text-primary-dark mr-8 text-center small">{{ $t('pages.schedule.time') }}</span>
                                    <el-timepicker class="w-100" v-model="mobile_wu_time" :minute-interval="15" :zero-based="true" @change="handleMobileWakupChanged" :hide-clear-button="true"></el-timepicker>
                                </div>
                                <div class="col-6 d-flex">
                                    <span class="my-auto d-block mb-16 text-primary-dark mr-8 text-center small">{{ $t('pages.schedule.duration') }}</span>
                                    <el-timepicker class="w-100" v-model="mobile_wu_duration" :minute-interval="15" :zero-based="true" @change="handleMobileWakupChanged" :hide-clear-button="true"></el-timepicker>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="text-center text-gray">
            {{ $t('pages.schedule.missing_in_bed_and_wakeup') }}
        </div>
    </div>
</template>

<script>
import ClickOutside from 'vue-click-outside'
import { Promise } from 'q';
import { ElTimepicker } from '@/components/forms'

export default {
    name: 'el-wakeup',

    props: {
        /**
         * Array defining the value
         * @type Array
         */
        value: {
            type: Array,
            required: true,
        },

        /**
         * String defining the date
         * @type String
         */
        date: {
            required: true,
        },

        /**
         * String defining the inBed
         * @type String
         */
        inBed: {
            required: true,
        },

        /**
         * String defining the aSleep
         * @type String
         */
        asleep: {
            required: true,
        },

        /**
         * String defining the wakeup
         * @type String
         */
        awake: {
            required: true,
        },

        /**
         * String defining the outBed
         * @type String
         */
        outBed: {
            required: true,
        },

        mobile: {
            required: false,
            default: false
        },

        wakeupColor: {
            type: String,
            default: 'var(--danger)',
        },

        wakeupColorHover: {
            type: String,
            default: 'red',
        },
    },

    components: { ElTimepicker },

    data: () => ({
        time_in_sleep: 0,
        time_in_sleep_rel: 0,
        time_out_sleep: 0,
        time_out_sleep_rel: 0,
        normalised: 0,
        normalised_15: 15,
        hours: 1,
        tst: 0,
        currentItem: {
            totalWidth: 0,
            visible: false,
            left: 0,
            time: '00:00',
            start: '00:00',
            end: '00:00',
        },
        wakeups: [],
        dragging: false,
        dragging_index: -1,
        editing_index: -1,
        dragging_start: '',
        hovering: false,

        mobile_wu_time: { HH: null, mm: null },
        mobile_wu_duration: { HH: null, mm: null },

        in_bed_date: null,
        asleep_date: null,
        awake_date: null,
        out_bed_date: null,
    }),
    mounted() {
        this.calcWidths()
        this.init()

        let self = this
        window.onresize = function () {
            self.calcWidths()
            self.init()
        }
    },
    destroyed() {
        document.getElementById('app').removeEventListener('click', this.clickOutside)
    },
    methods: {
        init() {
            let line = this.$refs.line;
            if (!line) return

            this.currentItem.totalWidth = this.$refs.timeline.clientWidth
            this.normalised = (this.currentItem.totalWidth / this.tst) * 100
            this.normalised_15 = Math.floor((15 / 100) * this.normalised)

            line.addEventListener("mouseenter", () => { this.currentItem.visible = true })
            line.addEventListener("mousemove", this.onMouseOver)
            line.addEventListener("mousedown", this.onMouseDown)
            line.addEventListener("mouseup", this.onMouseUp);

            [this.in_bed_date, this.asleep_date, this.awake_date, this.out_bed_date] = this.calculateDates(this.inBed, this.asleep, this.awake, this.outBed)

            document.getElementById('app').addEventListener('click', this.clickOutside, true)

            this.parseWakeups()
        },
        onMouseOver(e) {
            e.preventDefault();

            let steps = (this.normalised_15 === 0) ? e.offsetX : Math.floor((e.offsetX / this.normalised_15) + 0.5) * this.normalised_15
            let minutes = (steps / this.normalised_15) * 15


            if (minutes < this.time_in_sleep + 15 || minutes >= this.tst - this.time_out_sleep - 15) return
            let currentWakeup = this.wakeups[this.dragging_index]
            let hover_time = this.$moment(this.inBed, 'HH:mm').add(minutes, 'minutes')

            this.currentItem.left = steps
            this.currentItem.time = hover_time.format('HH:mm')

            if (currentWakeup) {
                if (steps - currentWakeup.left < 0) return
                currentWakeup.width = steps - currentWakeup.left + this.normalised_15
                currentWakeup.time = this.currentItem.time
                currentWakeup.end = currentWakeup.time

                if (steps - currentWakeup.left !== this.normalised_15) {
                    hover_time.add(15, 'minutes')
                    currentWakeup.time = hover_time.format('HH:mm')
                    currentWakeup.end = currentWakeup.time
                }

                let dur = this.$moment.duration(this.$moment(currentWakeup.end, 'HH:mm').diff(this.$moment(currentWakeup.start, 'HH:mm'))).asMinutes()
                if (dur < 0)
                    dur = this.$moment.duration(this.$moment(currentWakeup.end, 'HH:mm').diff(this.$moment(currentWakeup.start, 'HH:mm').subtract(1, 'day'))).asMinutes()

                if (dur < 0) currentWakeup.duration = 1440 + dur
                else currentWakeup.duration = dur
                this.currentItem.start = currentWakeup.start
            }
        },
        onMouseDown(e) {
            e.preventDefault();

            if (event.which !== 1) return

            if (!this.dragging) {
                let wakeup = {
                    left: this.currentItem.left,
                    width: this.normalised_15,
                    start: this.currentItem.time,
                    duration: 15
                }
                this.dragging = true
                this.dragging_index = this.wakeups.push(wakeup) - 1
                this.dragging_start = wakeup.start
            }
        },
        markerMouseDown(e, wu, index) {
            e.preventDefault();

            if (event.which !== 1) return

            if (!this.dragging) {
                this.dragging = true
                this.dragging_index = index
                this.dragging_start = wu.start
            }
        },
        onMouseUp() {
            this.$nextTick().then(() => {
                this.dragging = false
                this.editing_index = this.wakeups.sort((a, b) => a.left - b.left).findIndex((wu) => wu.start === this.dragging_start)
                if (this.wakeups[this.editing_index])
                    this.wakeups[this.editing_index].visible = true
                this.dragging_index = -1
                this.dragging_start = ''
                this.handleInput()
            })
        },
        handleInput() {
            this.autocorrect().then(() => {
                let result = Object.assign({}, this.wakeups)
                result = Object.keys(result).map(key => { return { start_time: result[key].start, end_time: this.$moment(result[key].start, 'HH:mm').add(result[key].duration, 'minutes').format('HH:mm') } })
                result = result.filter(r => r.start_time !== r.end_time)
                this.$emit('input', result)
            })
        },
        calcWidths() {
            let in_bed = this.$moment(this.inBed, 'HH:mm')
            let out_bed = this.$moment(this.outBed, 'HH:mm')
            let asleep = this.$moment(this.asleep, 'HH:mm')
            let awake = this.$moment(this.awake, 'HH:mm')
            if (in_bed.isAfter(out_bed)) { out_bed.add(1, 'd'); awake.add(1, 'd') }
            if (!asleep.isAfter(in_bed)) asleep.add(1, 'd')
            if (!out_bed.isAfter(awake)) awake.subtract(1, 'd')

            if (this.asleep !== this.inBed)
                this.time_in_sleep = this.$moment.duration(asleep.diff(in_bed)).asMinutes()
            else
                this.time_in_sleep = 0

            if (this.awake !== this.outBed)
                this.time_out_sleep = this.$moment.duration(out_bed.diff(awake)).asMinutes()
            else
                this.time_out_sleep = 0

            this.tst = this.$moment.duration(out_bed.diff(in_bed)).asMinutes()
            if (this.tst) {
                this.time_in_sleep_rel = (this.time_in_sleep / this.tst) * 100
                this.time_out_sleep_rel = (this.time_out_sleep / this.tst) * 100
                this.hours = Math.floor(this.tst / 60)
            }
        },
        handleMarkerClicked(event, wu, index) {
            wu.visible = true
            this.editing_index = index
        },
        handleMarkerClickedOutside() {
            if (this.wakeups.length > 0) {
                this.wakeups.forEach(wu => {
                    wu.visible = false
                })
                this.editing_index = -1
                this.$forceUpdate()
            }
        },
        removeWakeup(wu_index) {
            this.wakeups.splice(wu_index, 1)
            this.editing_index = -1
            this.handleInput()
        },
        parseWakeups() {
            this.wakeups = this.value.map((v) => {
                let in_bed = this.$moment(this.inBed, 'HH:mm')
                let start_time = this.$moment(v.start_time, 'HH:mm')
                if (this.$moment(this.inBed, 'HH:mm').isAfter(start_time))
                    in_bed = this.$moment(this.inBed, 'HH:mm').subtract(1, 'd')

                let start_duration = this.$moment.duration(this.$moment(v.start_time, 'HH:mm').diff(in_bed)).asMinutes()
                let duration = this.$moment.duration(this.$moment(v.end_time, 'HH:mm').diff(this.$moment(v.start_time, 'HH:mm'))).asMinutes()
                let duration_time = this.$moment().startOf('day').add(duration, 'minutes')
                if (duration < 0)
                    duration = this.$moment.duration(this.$moment(v.end_time, 'HH:mm').diff(this.$moment(v.start_time, 'HH:mm').subtract(1, 'day'))).asMinutes()

                return {
                    duration: duration,
                    start: v.start_time,
                    end: v.end_time,
                    left: (start_duration / 15) * this.normalised_15,
                    visible: false,
                    width: (duration / 15) * this.normalised_15,
                    mobile_time: { HH: start_time.format('HH'), mm: start_time.format('mm') },
                    mobile_duration: { HH: duration_time.format('HH'), mm: duration_time.format('mm') },
                }
            })
        },
        autocorrect() {
            return new Promise((resolve) => {
                this.mergeWakeUps(this.wakeups).then(wakeups => {
                    this.wakeups = wakeups
                    resolve()
                })
            })
        },
        handleMobileWakupChanged: _.debounce(function () {
            if (this.mobile_wu_time.HH && this.mobile_wu_time.mm && this.mobile_wu_duration.HH && this.mobile_wu_duration.mm) {
                let dur = parseInt(this.mobile_wu_duration.HH) * 60 + parseInt(this.mobile_wu_duration.mm)
                let [start, end] = this.calculateWakeupDates(`${this.mobile_wu_time.HH}:${this.mobile_wu_time.mm}`, dur, this.asleep_date)

                if (end >= this.awake_date) {
                    this.$emit('timesChanged', true)
                    end = this.awake_date.clone().subtract(15, 'minutes')
                    dur = this.$moment.duration(end.diff(start)).asMinutes()
                }
                if (start >= this.awake_date) {
                    this.$emit('timesChanged', true)
                    start = this.awake_date.clone().subtract(30, 'minutes')
                    end = this.awake_date.clone().subtract(15, 'minutes')
                    dur = 15
                }

                let start_duration = this.$moment.duration(this.in_bed_date.diff(start)).asMinutes()
                let wakeup = {
                    duration: dur,
                    start: start.format('HH:mm'),
                    end: end.format('HH:mm'),
                    left: (start_duration / 15) * this.normalised_15,
                    visible: false,
                    width: (dur / 15) * this.normalised_15,
                    mobile_time: { HH: this.mobile_wu_time.HH, mm: this.mobile_wu_time.mm },
                    mobile_duration: { HH: this.mobile_wu_duration.HH, mm: this.mobile_wu_duration.mm },
                }
                this.wakeups.push(wakeup)
                this.handleInput()
                this.$nextTick().then(() => {
                    this.mobile_wu_time = this.mobile_wu_duration = { HH: null, mm: null }
                })
            }
        }, 500),
        handleMobileWakupUpdate: _.debounce(function (wu) {
            if (wu.mobile_time.HH && wu.mobile_time.mm && wu.mobile_duration.HH && wu.mobile_duration.mm) {
                let dur = parseInt(wu.mobile_duration.HH) * 60 + parseInt(wu.mobile_duration.mm)
                let [start, end] = this.calculateWakeupDates(`${wu.mobile_time.HH}:${wu.mobile_time.mm}`, dur, this.asleep_date)

                if (end >= this.awake_date) {
                    this.$emit('timesChanged', true)
                    end = this.awake_date.clone().subtract(15, 'minutes')
                    dur = this.$moment.duration(end.diff(start)).asMinutes()
                }
                if (start >= this.awake_date) {
                    this.$emit('timesChanged', true)
                    start = this.awake_date.clone().subtract(30, 'minutes')
                    end = this.awake_date.clone().subtract(15, 'minutes')
                    dur = 15
                }

                let start_duration = this.$moment.duration(this.in_bed_date.diff(start)).asMinutes()
                wu.duration = dur
                wu.left = (start_duration / 15) * this.normalised_15
                wu.start = start.format('HH:mm')
                wu.end = end.format('HH:mm')

                this.handleInput()
            }
        }),
        calculateDates(inBedTime, asleepTime, awakenTime, outBedTime) {
            let inBed = this.$moment(this.date + ' ' + inBedTime, 'YYYY-MM-DD HH:mm')
            let asleep = this.$moment(this.date + ' ' + asleepTime, 'YYYY-MM-DD HH:mm')
            let awaken = this.$moment(this.date + ' ' + awakenTime, 'YYYY-MM-DD HH:mm')
            let outBed = this.$moment(this.date + ' ' + outBedTime, 'YYYY-MM-DD HH:mm')

            if (inBed.isAfter(outBed))
                outBed.add(1, 'days')

            if (inBed.isAfter(asleep))
                asleep.add(1, 'days')

            if (inBed.isAfter(awaken))
                awaken.add(1, 'days')

            return [inBed, asleep, awaken, outBed]
        },
        filterWakeupsDateChange(oldAsleep, newAsleep, awake) {
            return this.wakeups.filter(item => {
                const [start, end] = this.calculateWakeupDates(item.start, item.duration)

                return start > newAsleep && end < awake
            })
        },
        calculateWakeupDates(startTime, duration, asleep) {
            let start = this.$moment(this.date + ' ' + startTime, 'YYYY-MM-DD HH:mm')
            let end = start.clone().add(duration, 'm')

            if (start <= asleep) {
                start.add(1, 'd')
            }
            if (end <= asleep) {
                end.add(1, 'd')
            }
            return [start, end]
        },
        mergeWakeUps(wakeups) {
            return new Promise((resolve) => {
                let result = [], last;

                let sorted = [...wakeups].sort((a, b) => {
                    let [aStart, aEnd] = this.calculateWakeupDates(a.start, a.duration, this.asleep_date)
                    let [bStart, bEnd] = this.calculateWakeupDates(b.start, b.duration, this.asleep_date)
                    return aStart.diff(bStart) || aEnd.diff(bEnd)
                })
                sorted.forEach(wu => {
                    const [start, end] = this.calculateWakeupDates(wu.start, wu.duration, this.asleep_date)
                    let lastStart, lastEnd
                    if (last) {
                        [lastStart, lastEnd] = this.calculateWakeupDates(last.start, last.duration, this.asleep_date)
                    }
                    if (!last || start > lastEnd) {
                        result.push(last = wu)
                    }
                    else if (end > lastEnd) {
                        let dur = this.$moment.duration(end.diff(lastStart)).asMinutes()
                        let start_duration = this.$moment.duration(lastStart.diff(this.in_bed_date)).asMinutes()
                        last.duration = dur
                        last.end = wu.end;
                        last.left = (start_duration / 15) * this.normalised_15
                        last.width = (dur / 15) * this.normalised_15

                        last.mobile_time = { HH: lastStart.hours().toString().padStart(2, 0), mm: lastStart.minutes().toString().padStart(2, 0) }
                        last.mobile_duration = { HH: parseInt(dur / 60).toString().padStart(2, 0), mm: parseInt(dur % 60).toString().padStart(2, 0) }
                    }
                });
                resolve(result)
            })
        }
    },
    computed: {
        disabledHours() {
            const asleepHour = this.asleep_date.hours()
            const awakenHour = this.awake_date.hours()

            let disabledDates = []
            for (let i = 0; i < 24; i++) {
                if (asleepHour < awakenHour) {
                    if (i >= awakenHour || i < asleepHour) {
                        disabledDates.push(i)
                    }
                }
                if (asleepHour > awakenHour) {
                    if (i >= awakenHour && i < asleepHour) {
                        disabledDates.push(i)
                    }
                }
            }

            return disabledDates
        }
    },
    watch: {
        value: function () {
            this.parseWakeups()
        },
        inBed: function () { this.$nextTick(() => { this.calcWidths(); this.init(); this.handleInput() }) },
        asleep: function () {
            this.$nextTick((newDate, oldDate) => {
                this.calcWidths();
                this.init();

                if (this.in_bed_date && this.asleep_date && this.awake_date) {
                    let oldAsleep = this.$moment(this.date + ' ' + oldDate, 'YYYY-MM-DD HH:mm')
                    if (this.in_bed_date.isAfter(oldAsleep) || this.in_bed_date.isSame(oldAsleep))
                        oldAsleep.add(1, 'days')

                    this.wakeups = this.filterWakeupsDateChange(oldAsleep, this.asleep_date, this.awake_date)
                }

                this.handleInput()
            })
        },
        awake: function () {
            this.$nextTick(() => {
                this.calcWidths();
                this.init();
                if (this.in_bed_date && this.asleep_date && this.awake_date) {
                    this.wakeups = this.filterWakeupsDateChange(this.asleep_date, this.asleep_date, this.awake_date)
                }
                this.handleInput()
            })
        },
        outBed: function () { this.$nextTick(() => { this.calcWidths(); this.init(); this.handleInput() }) },
    },
    directives: {
        ClickOutside
    },
}
</script>